import { createFileRoute } from "@tanstack/react-router";

import { LegalDocumentPage } from "~/components/legal/LegalDocumentPage";

export const Route = createFileRoute("/(public)/cookies")({
  component: () => <LegalDocumentPage type="cookies" title="Cookiebeleid" />,
});
